import {noop} from "lodash";

export function resolveIf<T>(condition: boolean, executor: (resolve: (value: T | PromiseLike<T>) => void, reject: (reason?: any) => void) => void): Promise<T> {
  return new Promise(condition ? executor : noop);
}
